import { Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type React from 'react';
import { type Control, Controller, type FieldErrors } from 'react-hook-form';
import type { CompanyFormData } from '../../schemas/companyInfoSchema';
import { textFieldStyles } from './sharedStyles';

interface Props {
  control: Control<CompanyFormData>;
  errors: FieldErrors<CompanyFormData>;
  isRestricted: boolean;
}

export const PrimaryContactSection: React.FC<Props> = ({ control, errors, isRestricted }) => {
  const theme = useTheme();

  return (
    <Grid>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
        Primary Contact
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="company_contact_name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                disabled={isRestricted}
                fullWidth
                label="Contact Name"
                sx={textFieldStyles(theme)}
                error={!!errors.company_contact_name}
                helperText={
                  errors.company_contact_name?.message || `${field.value?.length || 0}/50`
                }
                inputProps={{ maxLength: 50 }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="company_contact_email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                disabled={isRestricted}
                fullWidth
                label="Contact Email"
                type="email"
                sx={textFieldStyles(theme)}
                error={!!errors.company_contact_email}
                helperText={
                  errors.company_contact_email?.message || `${field.value?.length || 0}/255`
                }
                inputProps={{ maxLength: 255 }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="company_contact_role"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                disabled={isRestricted}
                fullWidth
                label="Contact Role"
                sx={textFieldStyles(theme)}
                error={!!errors.company_contact_role}
                helperText={
                  errors.company_contact_role?.message || `${field.value?.length || 0}/50`
                }
                inputProps={{ maxLength: 50 }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Controller
            name="contact_facsimile"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                disabled={isRestricted}
                fullWidth
                label="Contact Facsimile"
                sx={textFieldStyles(theme)}
                error={!!errors.contact_facsimile}
                helperText={errors.contact_facsimile?.message || `${field.value?.length || 0}/50`}
                inputProps={{ maxLength: 50 }}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
